import React from 'react';
import PropTypes from 'prop-types';

import { SVG } from './Icon.styles';

export default function Icon({ name, onClick = () => {}, styles = [] }) {
  return (
    <SVG onClick={onClick} $styles={styles}>
      <use xlinkHref={`#icon-${name}`} />
    </SVG>
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  styles: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  ),
};
